import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2490. Board連携設定削除
 * [DELETE] /workspaces/:identifier/board_setting
 */
type Props = {
  identifier: string;
};

const destroyBoardSetting = (props: Props) => {
  return axios.delete(`/api/workspaces/${props.identifier}/board_setting`);
};

export const useDestroyBoardSetting = () => {
  return useMutation({
    mutationFn: destroyBoardSetting,
  });
};
